import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
export const Hero = () => {
  return <section id="inicio" className="relative pt-40 pb-20 md:pt-52 md:pb-32 px-6 md:px-12 max-w-7xl mx-auto min-h-screen flex items-center" data-id="element-125">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-8 items-center w-full" data-id="element-126">
        {/* Left: Typography & Copy */}
        <div className="flex flex-col z-10 max-w-xl" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col" data-id="element-128">
            <span className="font-script text-brand-cream text-6xl md:text-7xl -rotate-2 transform origin-left mb-[-10px] md:mb-[-20px] relative z-20 drop-shadow-sm" data-id="element-129">
              bienvenidos a
            </span>
            <h1 className="font-serif text-brand-charcoal text-7xl md:text-[110px] leading-[0.85] tracking-tight relative z-10" data-id="element-130">
              PinzColors
            </h1>
            <span className="font-script text-brand-cream text-4xl md:text-5xl self-end mr-8 md:mr-12 mt-[-10px] md:mt-[-20px] relative z-20 drop-shadow-sm" data-id="element-131">
              by Laura Pinzón
            </span>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mt-10 text-brand-charcoal/80 font-light text-lg md:text-xl leading-relaxed max-w-md" data-id="element-132">
            Eleva tu estilo con un cuidado de uñas premium. Arte, precisión y
            durabilidad en cada detalle.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="mt-10" data-id="element-133">
            <a href="https://wa.me/584244582867" target="_blank" rel="noreferrer" className="glass-button inline-flex items-center gap-3 px-8 py-4 rounded-full font-medium tracking-wide text-brand-charcoal transition-all hover:scale-105 hover:shadow-xl group" data-id="element-134">
              <WhatsAppIcon className="w-6 h-6 text-brand-charcoal group-hover:scale-110 transition-transform" data-id="element-135" />
              Apartar Turno vía WhatsApp
            </a>
          </motion.div>
        </div>

        {/* Right: Image Container */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative w-full max-w-md mx-auto lg:ml-auto lg:mr-0" data-id="element-136">
          <motion.div animate={{
          y: [-6, 6, -6]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative aspect-[3/4] w-full" data-id="element-137">
            {/* The Image */}
            <div className="absolute inset-0 rounded-tl-[120px] rounded-br-[120px] rounded-tr-3xl rounded-bl-3xl overflow-hidden shadow-[0_30px_70px_-20px_rgba(0,0,0,0.4)]" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/b6qQbYnmAtmf1NtVmEvTQU/BANNER.jpg" alt="Nail Art Macro" fetchpriority="high" decoding="async" className="w-full h-full object-cover" data-id="element-139" />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 glass-panel px-6 py-4 rounded-3xl flex items-center gap-3 shadow-xl" data-id="element-140">
              <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-charcoal" data-id="element-141">
                <Star size={20} fill="currentColor" data-id="element-142" />
              </div>
              <div data-id="element-143">
                <p className="font-serif italic text-lg leading-none" data-id="element-144">
                  Premium
                </p>
                <p className="font-sans text-xs tracking-widest uppercase mt-1 opacity-70" data-id="element-145">
                  Nail Care
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};